import React from 'react';

// Components
import HtmlPartWithCss from '../../parts/HtmlPartWithCss';

function HtmlCard({ customItems = [], id }) {
  const html = customItems.find(x => x.Tag === 'HTML');
  const css = customItems.find(x => x.Tag === 'CSS');
  return (
    <HtmlPartWithCss
      htmlString={html ? html.Value : ''}
      cssString={css ? css.Value : ''}
      escapeId={`html-card-scope--${id}`}
      ommitBaseStyles
    />
  );
}

export default HtmlCard;



// WEBPACK FOOTER //
// ./src/cards/templates/HtmlCard.js